import React from "react";
import { Navigate } from "react-router-dom";

import { isBrandedUser } from "@modules/authentication/Patient";
import { usePatientProfile } from "@modules/authentication/PatientProfileProvider";
import { ProfileLoadError } from "@modules/authentication/ProfileLoadError";
import { BrandNeutralLoading } from "common/NoomLoader";

export const HomePage = () => {
  // `/` opts out of the telehealth-patient gate (`requiresPatient: false`) and
  // acts as a status-aware redirector, so a non-patient who lands here after
  // web login is routed to the open `/care` page instead of being logged out.
  const { profile, status } = usePatientProfile();

  // Reached only behind SecureRoute (so the user is authenticated).
  if (status === "not-patient") {
    return <Navigate to="/care" />;
  }

  // A transient profile fetch failure would otherwise leave us spinning forever
  // (the redirect below never runs), so surface a retryable error instead.
  if (status === "error") {
    return <ProfileLoadError />;
  }

  // Still resolving — show a loader rather than bouncing to login.
  if (status !== "patient" || !profile) {
    return <BrandNeutralLoading />;
  }

  // Patient: redirect based on user type.
  if (!isBrandedUser(profile.patient_type)) {
    return <Navigate to="/shipping-and-refills" />;
  }
  return <Navigate to="/visits/past" />;
};
